import { Dispatch } from 'redux'
import {
  add as addAction,
  deleteUser as deleteUserAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/user-admin/actions'
import { Payload } from 'states/dux/user-admin/types'
import { Action } from 'states/types'
import { NivosUser } from 'types/user'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (users: NivosUser[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: users
      })
    )
}

const update = (user: NivosUser): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [user]
      })
    )
}

const add = (user: NivosUser): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [user]
      })
    )
}

const deleteUser = (user: NivosUser): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      deleteUserAction({
        loading: false,
        data: [user]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (users: NivosUser[]) => DispatchAction
  add: (user: NivosUser) => DispatchAction
  deleteUser: (user: NivosUser) => DispatchAction
  update: (user: NivosUser) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  deleteUser,
  update,
  loading
}

export { operations, set }
